module.exports = __webpack_public_path__ + "img/puzzle-piece.a8cca42e.svg";